import { ApiClient } from "#/shared/api/client";
import { Candidate } from "#ce/apps/SpAiGeneratorApp/models/candidate";

class GeneratorApi extends ApiClient {
  constructor(options) {
    super({ ...options, api: "field_content_generator", model: Candidate });
  }
}

export function createGeneratorApi(urlString) {
  const url = new URL(urlString);
  const { origin, pathname, searchParams } = url;

  const params = Object.fromEntries(searchParams.entries());
  const api = new GeneratorApi({ baseURL: origin });

  return {
    async generateContent(data = {}) {
      return await api.post(pathname, { ...data, ...params });
    },
  };
}
